import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

export const MotionContainer = styled(motion.div)`
${({
    disabled, variants,
  }) => css`
  grid-area: status;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid gray;
  background-color: ${variants.backgroundColor};
  & h2 {
    margin: 0px;
    color: ${disabled ? '#666' : variants.color};
  }
`}
`;

export default MotionContainer;
